import { call } from 'redux-saga/effects';

let initModule = null;
export function* initPurchaseTv({ payload }) {
  if (!initModule) {
    initModule = yield call(() => import('./init'));
  }
  // llamada a modulo
  yield call(initModule.initPurchaseTv, { payload });
}
let checkOutModule = null;
export function* checkoutTv({ payload }) {
  if (!checkOutModule) {
    checkOutModule = yield call(() => import('./checkout'));
  }
  // llamada a modulo
  yield call(checkOutModule.checkoutTv, { payload });
}
let processOrderModule = null;
export function* processOrderTv() {
  if (!processOrderModule) {
    processOrderModule = yield call(() => import('./process-order'));
  }
  // llamada a modulo
  yield call(processOrderModule.processOrderTv, {});
}
let sendPurchaseOtpModule = null;
export function* sendPurchaseOtpTv({ payload }) {
  if (!sendPurchaseOtpModule) {
    sendPurchaseOtpModule = yield call(() => import('./send-purchase-otp'));
  }
  // llamada a modulo
  yield call(sendPurchaseOtpModule.sendPurchaseOtpTv, {
    payload,
  });
}
let validatePurchaseOtpModule = null;
export function* validatePurchaseOtpTv({ payload }) {
  if (!validatePurchaseOtpModule) {
    validatePurchaseOtpModule = yield call(() =>
      import('./validate-purchase-otp')
    );
  }
  // llamada a modulo
  yield call(validatePurchaseOtpModule.validatePurchaseOtpTv, {
    payload,
  });
}
